import './style.scss'

import { mapGetters } from 'vuex'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'

export default {
  name: 'Breadcrumbs',
  props: ['page'],
  computed: {
    ...mapGetters(['getParentsById', 'getStringTranslation', 'loaded', 'lang']),
    breadcrumbItems () {
      return this.getParentsById(this.page.id)
    }
  },
  methods: {
    getTranslation (translationTitle) {
      return this.getStringTranslation(translationTitle)
    }
  },
  render (h) {
    /* TODO: This should be an array of item with links */
    const { loaded, breadcrumbItems, lang } = this
    return (
      <nav class='Breadcrumbs'>
      {loaded
        ? <ul class='Breadcrumbs__list'>
          <li class='Breadcrumbs__list-item'>
            <router-link to={lang === 'en' ? '/en' : '/'} class={'Breadcrumbs__list-item-link'}>
              {this.getTranslation('home')}
            </router-link>
          </li>
          {breadcrumbItems.map(i => (
            <li class='Breadcrumbs__list-item'>
              <router-link to={verifyLeadingSlashLang(i.uri, lang)} class={'Breadcrumbs__list-item-link'}>
                {i.title.rendered}
              </router-link>
            </li>
          ))}
        </ul>
      : 'Loading…' }
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Breadcrumbs/index.js